import { activityFeed } from 'services/analytics/events';
import { trackingDocumentListViewPrimaryFeed } from './trackDocumentList';

export const trackingActivityFeed = (totalNodes: number) => {
  activityFeed.viewFeed();
  trackingDocumentListViewPrimaryFeed(totalNodes);
  return;
};
